import { render, staticRenderFns } from "./Kunst-Design.vue?vue&type=template&id=18b1e824&scoped=true&"
var script = {}
import style0 from "./Kunst-Design.vue?vue&type=style&index=0&id=18b1e824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1e824",
  null
  
)

export default component.exports